import { ReactElement, useState } from 'react';

import { Button } from '@components/atoms/Button';
import { PrismicRichText } from '@prismicio/react';

import { clsx } from 'clsx';
import Link from 'next-translate-routes/link';

import { IProps } from './types';
import * as S from './styles';

export function SliceColorSample({
  slice: { primary, fields },
  context: { isMinimalist },
}: IProps): ReactElement {
  const [activeColor, setActiveColor] = useState<string | null>('');

  return (
    <S.Wrapper className="color-sample">
      <S.Header>
        {primary.title && <PrismicRichText field={primary.title} />}
      </S.Header>
      <S.Colors className="color-sample__colors">
        {fields &&
          fields?.map((c, i) => (
            <button
              type="button"
              className={clsx('color-sample__colors-item', {
                active: c.color === activeColor,
              })}
              style={{ backgroundColor: c.color || '' }}
              onClick={() => setActiveColor(c.color)}
              key={i}
            >
              {c.color}
            </button>
          ))}
      </S.Colors>
      <S.Description className="color-sample__descr">
        {primary.text && <PrismicRichText field={primary.text} />}
      </S.Description>
      {primary.cta_link && (
        <S.Link className="color-sample__link">
          {/* <Link
            className="button red"
            to={removeDomainFromUrl(primary.cta_link)}
          > */}
          <Link href="/collection/sample/10">
            <a>
              <Button>{primary.cta_label}</Button>
            </a>
          </Link>
        </S.Link>
      )}
    </S.Wrapper>
  );
}

SliceColorSample.componentName = 'color_sample';
